import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const InputTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputTextValidationLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  white-space: pre-line;

  color: ${({ theme }) => (theme.isError ? 'var(--color-error)' : 'var(--color-text)')};
`;

export const InputTextFieldTextarea = styled.textarea`
  user-select: text;
  height: 56px;
  width: 100%;

  padding: 15px 10px;

  background: rgba(173, 173, 173, 0.08);
  border-radius: 8px;
  outline: none;
  border: none;

  ${({ theme }) =>
    theme.isError &&
    `
    border: 1px solid var(--color-error) !important;
  `}

  font-weight: 400;
  font-size: 14px;
  line-height: 23px;

  & > :focus {
    border: 1px solid var(--color-data-company-background-hover);
  }

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: rgba(173, 173, 173, 0.3);
    border: 1px solid rgba(23, 28, 51, 0.5);

    & > span {
      color: #949494 !important;
    }
  `}

  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: normal;
    text-align: start;

    color: rgba(23, 28, 51, 0.5);
  }

  position: relative;
`;

export const InputTextField = styled.input`
  user-select: text;
  height: 56px;
  width: 100%;

  padding: 15px 10px;

  background: rgba(173, 173, 173, 0.08);
  border-radius: 8px;

  ${({ theme }) =>
    theme.isError &&
    `
    border: 1px solid var(--color-error) !important;
  `}

  font-weight: 400;
  font-size: 14px;
  line-height: 23px;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  & > :focus {
    border: 1px solid var(--color-data-company-background-hover);
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: rgba(173, 173, 173, 0.3);
    border: 1px solid rgba(23, 28, 51, 0.5);

    & > span {
      color: #949494 !important;
    }
  `}

  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: normal;
    text-align: start;

    color: rgba(23, 28, 51, 0.5);
  }

  position: relative;
`;

export const InputTextPlaceholder = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: rgba(23, 28, 51, 0.5);

  position: absolute;
  top: 15px;
  left: 10px;

  user-select: none;
  pointer-events: none;
`;

export const InputTextLimit = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(23, 28, 51, 0.5);
`;

export const InputTextErrorContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const InputTextError = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--color-error);
`;
